import fetchr from "./fetchr";
import { HIDDENFAULTS_TOKEN, HIDDENFAULTS_REFRESH } from "./constants";

export const postUnemploymentApplication = async (application) => {
    try {
        const response = await fetchr(`/application/CreateApplicationUnemployment`).postForm(application);
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const postWorkIncapacityApplication = async (application) => {
    try {
        const response = await fetchr(`/application/CreateApplicationWorkIncapacity`).postForm(application);
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const postHospitalisedApplication = async (application) => {
    try {
        const response = await fetchr(`/application/CreateApplicationHospitalised`).postForm(application);
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const postUpdateClaimApplication = async ( application,url) => {
    try {
        const response = await fetchr(url).postForm(application);
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const validateClaimDate = async (claimDate) => {
    try {
        var formattedDate = new Date(claimDate).toJSON();
        const response = await fetchr(
            `/claimDate/${formattedDate}`
        ).get();
        const result = await response.json();
        return result;
    } catch (error) {

        return null;
    }
};

export const getInsuranceDocument = async (docId) => {
    try {
        const response = await fetchr(
            `/insurancedocument/${docId}`
        ).get();
        return response;
    } catch (error) {
        return null;
    }
};

export const logOut = async () => {
    sessionStorage.removeItem(HIDDENFAULTS_TOKEN);
    sessionStorage.removeItem(HIDDENFAULTS_REFRESH);
};

export const getCustomerData = async () => {
    try {
        const response = await fetchr(`/customer`).get();
        const data = await response.json();
        return data;
    } catch (error) {
        console.log(error);
        return null;
    }
};
